import React from "react";
import { Tag, Tooltip } from "antd";
import { ellipsize, getValueByKey } from "../../../../helper/helpers";

const Tags = ({
  disabled,
  maxTags,
  onChange,
  optionLabelProp,
  optionValueProp,
  value = [],
}) => {
  const tagCloseHandler = (datum) => () => {
    const selectedValues = value.filter(
      (item) =>
        getValueByKey(item, optionValueProp) !==
        getValueByKey(datum, optionValueProp)
    );

    onChange(selectedValues);
  };

  return (
    <>
      {value.slice?.(0, Math.min(maxTags, value.length)).map((item) => {
        return (
          <Tooltip
            key={getValueByKey(item, optionValueProp)}
            title={getValueByKey(item, optionLabelProp)}
          >
            <Tag
              className="select-item-tag"
              key={item.value}
              closable={!disabled}
              onClose={tagCloseHandler(item)}
            >
              {ellipsize(getValueByKey(item, optionLabelProp), 10)}
            </Tag>
          </Tooltip>
        );
      })}
      {value?.length > maxTags && (
        <Tooltip
          title={[...value]
            .slice(maxTags)
            .map((i) => getValueByKey(i, optionLabelProp))
            .join(", ")}
        >
          <Tag>+{value.length - maxTags}</Tag>
        </Tooltip>
      )}
    </>
  );
};

export default Tags;
